import React from "react";

const SuccessModal = ({
  isOpen,
  title = "Thank you!",
  message = "We will contact you shortly.",
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-black/60 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 className="text-2xl font-bold text-blue-900">{title}</h2>
        <p className="mt-3 text-base text-gray-600">{message}</p>
        <button
          type="button"
          className="mt-6 rounded bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;
